import React, { useState, useEffect } from 'react';

const ExitIntentPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    // Check if popup was already shown in this session
    const popupShown = sessionStorage.getItem('exitPopupShown');
    if (popupShown) {
      setHasShown(true);
      return;
    }

    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !hasShown) {
        setShowPopup(true);
        setHasShown(true);
        sessionStorage.setItem('exitPopupShown', 'true');
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [hasShown]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Send to email
    const formElement = document.createElement('form');
    formElement.action = 'https://formsubmit.co/contact@enessafoods.com';
    formElement.method = 'POST';
    formElement.style.display = 'none';
    
    const fields = [
      { name: '_subject', value: 'Website Visitor - Exit Intent Signup' },
      { name: 'Name', value: formData.name },
      { name: 'Email', value: formData.email },
      { name: 'Phone', value: formData.phone },
      { name: '_captcha', value: 'false' },
      { name: '_template', value: 'table' },
      { name: '_next', value: window.location.href }
    ];
    
    fields.forEach(field => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = field.name;
      input.value = field.value;
      formElement.appendChild(input);
    });
    
    document.body.appendChild(formElement);
    formElement.submit();
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] p-4 animate-fadeIn">
      <div className="bg-white rounded-3xl p-8 max-w-lg w-full shadow-2xl animate-slideUp" onClick={(e) => e.stopPropagation()}>
        <button 
          onClick={() => setShowPopup(false)}
          className="float-right text-gray-400 hover:text-gray-600 text-2xl font-bold"
        >
          ×
        </button>
        
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold text-[#3b1b0d] mb-3">Wait! Before You Go...</h2>
          <p className="text-[#7b5b3a] text-lg">
            Get exclusive baking tips, product updates, and special offers delivered to your inbox!
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              placeholder="Your Name *"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
              required
            />
          </div>
          <div>
            <input
              type="email"
              placeholder="Your Email *"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
              required
            />
          </div>
          <div>
            <input
              type="tel"
              placeholder="Your Phone (Optional)"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
            />
          </div>
          
          <button
            type="submit"
            className="w-full bg-[#b42b2b] text-white px-6 py-4 rounded-full font-medium text-lg hover:bg-[#8f2222] transition-colors"
          >
            Yes, Keep Me Updated! 🎉
          </button>
          
          <button
            type="button"
            onClick={() => setShowPopup(false)}
            className="w-full text-gray-500 text-sm hover:text-gray-700"
          >
            No thanks, I'll miss out
          </button>
        </form>

        <p className="text-xs text-gray-400 text-center mt-4">
          We respect your privacy. Unsubscribe anytime.
        </p>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
